<!--
 * @Author: cgh
 * @Date: 2022-08-19 17:48:22
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:43:20
 * @Description: 打印标签
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="打印标签"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmmc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="计划年份"
              prop="jhnf"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jhnf | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="计划名称"
              prop="jhmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jhmc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="计划类型"
              prop="jhlxMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jhlxMc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="项目负责人"
              prop="xmfzrMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmfzrMc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="起止日期"
              prop="qzrq"
            >
              <span
                class="c-form__read"
              >
                {{ fd.rqq | date('yyyy-MM-dd') }} ~  {{ fd.rqz | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="打印标签"
        :auth-type="true"
        type="primary"
        @click="handleDybq()"
      />
      <k-button
        btn-text="下载标签"
        :auth-type="false"
        type="primary"
        @click="handleXzbq()"
      />
      <k-button
        btn-text="下载公示牌"
        :auth-type="false"
        type="primary"
        @click="handleXzgsp()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { bgglService } from './bggl.service.js';
export default {
  name: 'AddDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      id: null,
      /* 表单参数 Start */
      fd: {
        xmmc: null, // 项目名称
        jhnf: null, // 计划年份
        jhmc: null,
        jhlx: null,
        xmfzrMc: null,
        rqq: null,
        rqz: null
      }
      /* 表单参数 End */

    };
  },
  computed: {

  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init () {
      this.loading = true;
      bgglService.getDybqInfo(this.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('打印标签获取信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 打印标签
     * @param {*}
     * @return {*}
     */
    handleDybq () {
      const _this = this;
      _this.$confirm('是否确认打印此任务标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.dybq(this.id)
          .then(rsp => {
            window.print();
          })
          .catch(err => {
            console.error('打印标签失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 下载标签
     * @param {*}
     * @return {*}
     */
    handleXzbq () {
      const _this = this;
      _this.$confirm('是否确认下载任务标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.xzbq(this.id)
          .then(rsp => {
            _this.$alert('下载标签成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('打印标签失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 打印标签
     * @param {*}
     * @return {*}
     */
    handleXzgsp () {
      const _this = this;
      _this.$confirm('是否确认下载公示牌？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.dybq(this.id)
          .then(rsp => {
            _this.$alert('下载公示牌成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('下载公示牌失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }
  },
  created () {
    if (this.dlParams.id) {
      this.id = this.dlParams.id;
      this.init();
    }
  }
};

</script>
